export default __webpack_public_path__ + "static/media/hero-logo.996da740.svg";